import React from "react";
import { Link } from "react-router-dom";

const ClosingCTA = () => {
  return (
    <section className="bg-primary-950 py-16">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6 lg:px-8">
        <p className="break-keep text-xl font-bold leading-relaxed text-white sm:text-2xl">
          MTST와 함께 스마트 제조의 다음을 만들어가세요.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link
            to="/technology"
            className="inline-flex items-center rounded-md bg-white px-6 py-3 text-base font-semibold text-primary-900 transition-colors hover:bg-gray-100"
          >
            솔루션 살펴보기
          </Link>
          <Link
            to="/careers"
            className="inline-flex items-center rounded-md border border-primary-700 px-6 py-3 text-base font-semibold text-white transition-colors hover:bg-primary-900"
          >
            우리와 함께하기
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ClosingCTA;
